<template>
  <div>
    <tree-transfer :title="title" :from_data='fromData' :to_data='toData' @add-btn='add' pid="parentId"
                   @remove-btn='remove' height='540px' openAll>
    </tree-transfer>
    <div style="margin-top: 20px;display: flex;justify-content: flex-end;">
      <Button type="primary" @click="commit">确 定</Button>
      <Button @click="clear" style="margin-left: 10px;">清 除</Button>
      <Button @click="cancel" style="margin-left: 10px;">取消</Button>
    </div>
  </div>
</template>
<script>
  import treeTransfer from 'el-tree-transfer'
  import $api from "@/apiProvider";

  export default {
    components: {treeTransfer},
    data() {
      return {
        fromData: [],
        toData: [],
        title: ['部门列表', '已选择']
      }
    },
    methods: {
      commit() {
        this.$emit('selectDepart', this.toData);
      },
      clear() {
        this.toData = [];
        this.getDepartmentList();
      },
      cancel() {
        this.$emit('close')
      },
      init(data) {
        this.toData = JSON.parse(JSON.stringify(data));
        this.getDepartmentList();
      },
      add(fromData, toData, obj) {

      },
      remove(fromData, toData, obj) {

      },
      async getDepartmentList() {
        let res = await $api.department.get('list');
        if (res.status === 1) {
          res.data.map(i => {
            i.label = i.shortName ? i.shortName : i.name;
            i.disabled = true;
            i.departmentList.map((j, index) => {
              j.label = j.name;
              j.parentName = i.label;
            })
            i.children = i.departmentList;
          })
          this.fromData = res.data;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
    }
  }
</script>
<style>

</style>